// extracted by mini-css-extract-plugin
export default {"container":"kp-z","ratingLayout":"lp-z","ratingLabel":"mp-z","nonInteractiveRatingLabel":"np-z"};